import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--select"
export default class extends Controller {

  static targets = ['cameraToggle', 'selectToggle'];


  connect() {
    this.selectToggleTarget.checked = this.cameraToggleTargets.some(el => el.checked);
  }

  selectAll(event) {
    event.stopPropagation();

    this.selectToggleTarget.disabled = this.selectToggleTarget.checked;

    const hasCheckedElement = this.enabledChecks().some(el => el.checked);
    this.toggleCheck(hasCheckedElement);

    setTimeout(() => {
      this.enabledChecks().some(el => el.disabled);
      this.selectToggleTarget.disabled = false;
    }, 1000);

  }

  checkedButton() {
    this.selectToggleTarget.checked = this.enabledChecks().some(element => element.checked);
  }


  toggleCheck(hasCheckedElement) {
    if (hasCheckedElement) {
      this.selectCheckFalse()
    } else {
      this.selectCheckTrue()
    }
  }


  selectCheckTrue() {
    this.enabledChecks().forEach(element => {
      if (!element.checked) {
        element.click();
        element.disabled = true
      }
      setTimeout(() => {
        if (element.checked) {
          element.disabled = false
        }
      }, 1000);
    });
  }


  selectCheckFalse() {
    this.enabledChecks().forEach(element => {
      if (element.checked) {
        element.click();
      }
    });
  }


  enabledChecks() {
    return this.cameraToggleTargets.filter(element => {
      return !element.disabled
    })
  }


  disconnect() {
    this.cameraToggleTargets.forEach(el => {
      el.checked = false
      el.disabled = false
    })

    this.selectToggleTargets.forEach(t => {
      t.checked = false
      t.disabled = false
    })
  }

}
